import { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api/client.ts';

import type { SuppressionType } from '../types.ts';

export function Suppression() {
  const queryClient = useQueryClient();
  const [type, setType] = useState<SuppressionType>('EMAIL');
  const [value, setValue] = useState('');
  const [reason, setReason] = useState('manual');
  
  const { data, isLoading } = useQuery({
    queryKey: ['suppression'],
    queryFn: () => api.listSuppression()
  });

  const addMutation = useMutation({
    mutationFn: () => api.addSuppression({ type, value, reason }),
    onSuccess: () => {
      setValue('');
      queryClient.invalidateQueries({ queryKey: ['suppression'] });
    }
  });

  if (isLoading) return <div>Loading...</div>;

  return (
    <div style={{ padding: '24px' }}>
      <h1>Suppression List</h1>
      <p style={{ color: '#94a3b8' }}>Manage blocklists for domains, emails, organizations, and people.</p>
      
      <div style={{ background: '#1e293b', padding: '20px', borderRadius: '8px', border: '1px solid #334155', marginBottom: '24px' }}>
        <h3>Add Suppression</h3>
        <div style={{ display: 'flex', gap: '12px', marginTop: '12px' }}>
          <select value={type} onChange={e => setType(e.target.value as SuppressionType)} style={{ padding: '8px' }}>
            <option value="EMAIL">Email</option>
            <option value="DOMAIN">Domain</option>
            <option value="COMPANY">Company</option>
          </select>
          <input 
            type="text" 
            placeholder="Value (e.g. acme.com)" 
            value={value} 
            onChange={e => setValue(e.target.value)} 
            style={{ padding: '8px', flex: 1 }} 
          />
          <select value={reason} onChange={e => setReason(e.target.value)} style={{ padding: '8px' }}>
            <option value="manual">Manual Request</option>
            <option value="competitor">Competitor</option>
            <option value="policy">Policy</option>
          </select>
          <button 
            onClick={() => addMutation.mutate()}
            disabled={!value || addMutation.isPending}
            style={{ background: '#dc2626', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer' }}
          >
            Block
          </button>
        </div>
      </div>

      <table style={{ width: '100%', borderCollapse: 'collapse', background: '#1e293b', border: '1px solid #334155' }}>
        <thead style={{ background: '#334155' }}>
          <tr>
            <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #334155' }}>Type</th>
            <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #334155' }}>Value</th>
            <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #334155' }}>Reason</th>
            <th style={{ padding: '12px', textAlign: 'left', borderBottom: '1px solid #334155' }}>Date</th>
            <th style={{ padding: '12px', textAlign: 'right', borderBottom: '1px solid #334155' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {data?.map(s => (
            <tr key={s.id}>
              <td style={{ padding: '12px', borderBottom: '1px solid #334155' }}>{s.type}</td>
              <td style={{ padding: '12px', borderBottom: '1px solid #334155' }}><strong>{s.value}</strong></td>
              <td style={{ padding: '12px', borderBottom: '1px solid #334155' }}>{s.reason}</td>
              <td style={{ padding: '12px', borderBottom: '1px solid #334155' }}>{s.suppressedAt ? new Date(s.suppressedAt).toLocaleString() : 'N/A'}</td>
              <td style={{ padding: '12px', borderBottom: '1px solid #334155', textAlign: 'right' }}>
                <button 
                  onClick={async () => {
                    if (confirm('Remove suppression?')) {
                      await api.removeSuppression(s.id);
                      queryClient.invalidateQueries({ queryKey: ['suppression'] });
                    }
                  }}
                  style={{ background: 'none', color: '#2563eb', border: 'none', cursor: 'pointer' }}
                >
                  Remove
                </button>
              </td>
            </tr>
          ))}
          {data?.length === 0 && (
            <tr><td colSpan={5} style={{ padding: '24px', textAlign: 'center', color: '#94a3b8' }}>No records found.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
